/**
 * 💬 **저장이 안 됐을 때 뭐라고 말할지** — 한 곳에서 정한다.
 *
 * 🔴 화면마다 따로 적으면 **이유를 삼킨다.** 실제로 그랬다: 무엇이 잘못됐든
 * 「저장 실패(엣지 확인)」이라, 「다른 곳에서 먼저 올렸어요」로 막힌 것도
 * **서버가 꺼진 것처럼** 보였다. 운영자는 엉뚱한 데를 본다.
 *
 * 규칙은 둘뿐이다:
 * ① 열쇠(401)는 「새 열쇠를 넣고 다시」 — 새로고침시키지 않는다(편집물이 날아간다)
 * ② 사람이 읽을 말이 오면 **그대로 보여 준다**. 숫자만 있는 것(HTTP 상태)일 때만 뭉뚱그린다
 */
export function saveFailSay(e: unknown, what = "저장"): string {
  const why = e instanceof Error ? e.message : String(e ?? "");
  if (why === "401") return "열쇠가 오래됐어요. 새 열쇠를 넣고 다시 눌러 주세요.";
  // 숫자만 = HTTP 상태. 사람에게 보여 줄 말이 아니다
  if (!why || /^\d+$/.test(why)) return `${what} 실패(엣지 확인).`;
  return `⚠️ ${why}`;
}
